<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="adduser"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ $t("add_user") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="adduser">
              <div class="form-group">
                <label>{{ $t("full_name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="fullname"
                  class="form-control"
                  required
                  @keypress="isLetter($event)"
                />
                <div
                  v-show="selectNotification !== ''"
                  class="alert-danger alert-dismissible fade show"
                >
                  <p>{{ selectNotification }}</p>
                </div>
              </div>

              <div class="form-group">
                <label for="InputNumber">{{ $t("phone") }}</label>
                <div class="form-group">
                  <input class="form-control" type="tel" id="phone_number" />
                </div>
                <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                  {{ ErrorPhone }}
                </p>
              </div>
              <div class="form-group">
                <label>{{ $t("email") }}</label>
                <input
                  type="email"
                  name="email"
                  v-model="email"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>{{ $t("user_rights") }}</label>
                <select
                  v-model="role"
                  name="role"
                  class="form-control"
                  required
                >
                  <option value="staff">{{ $t("staff") }}</option>
                  <option value="manager">{{ $t("manage") }}</option>
                  <option value="admin">{{ $t("admin") }}</option>
                </select>
              </div>
              <div
                style="display:flex; justify-content: end"
              >
                <!-- <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button> -->
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="selectNotification !== ''"
                >
                  {{ $t("add_user") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "AddUser",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      role: "staff",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
    };
  },
  components: {
    Loading,
  },
  mounted() {
    setTimeout(() => {
      var input = document.querySelector("#phone_number");
      this.iti = intlTelInput(input, {
        separateDialCode: true,
        utilsScript: utils,
      });
      this.iti.setCountry("ng");
    }, 200);
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["addUser", "getUsers"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      // // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    onCancel() {
      this.$emit("closeAddUserModal");
    },
    adduser() {
      if (this.selectNotification !== "") return;
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        const newUser = {
          email: this.email.toLowerCase(),
          phone: `${parseInt(number)}`,
          fullname: this.fullname,
          role: this.role,
        };
        this.addUser(newUser)
          .then((res) => {
            this.getUsers().then(() => {
              this.onCancel();
            });
            this.isLoading = false;
            this.$emit('showSuccessPopup')
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            // setTimeout(() => {
            //   this.isLoading = true;
            // }, 1000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
  watch: {
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname))
          return (this.selectNotification = "");
        else this.selectNotification = this.$t("must_contain");
      },
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
</style>
<i18n>
{
	"en": {
		"add_user": "Add a User",
		"all_users": "All Users",
		"edit_user": "Edit User",
		"email": "Email",
		"full_name": "Full Name",
		"man_user_right": "Manage user rights for members of your business",
		"manage": "Manager",
		"must_contain": "Must conain only Letters",
		"name": "Name",
		"phone": "Phone Number",
		"staff": "Staff",
		"user_rights": "User Rights",
		"valid_phone": "This phone number is not valid"
	},
	"fr": {
		"add_user": "Ajouter un utilisateur",
		"all_users": "Tous les utilisateurs",
		"edit_user": "Modifier l'utilisateur",
		"email": "E-mail",
		"full_name": "Nom et prénom",
		"man_user_right": "Gérez les droits d'utilisation des membres de votre entreprise",
		"manage": "Directeur",
		"must_contain": "Ne doit contenir que des lettres",
		"name": "Nom",
		"phone": "Numéro de téléphone",
		"staff": "Personnel",
		"user_rights": "Droits de l'utilisateur",
		"valid_phone": "Ce numéro de téléphone n'est pas valide"
	},
	"sw": {
		"add_user": "ONGEZA MTUMIAJI",
		"all_users": "Watumiaji Wote",
		"edit_user": "Badilisha mtumiaji",
		"email": "Barua pepe",
		"full_name": "Jina kamili",
		"man_user_right": "Dhibiti haki za mtumiaji za wanachama wa biashara yako",
		"manage": "Meneja",
		"must_contain": "Lazima iwe na Barua tu",
		"name": "Jina",
		"phone": "Nambari ya simu",
		"staff": "STAFF",
		"user_rights": "Haki za Mtumiaji",
		"valid_phone": "Nambari hii ya simu si sahihi"
	}
}
</i18n>
